import { createTheme } from '@mui/material/styles';
// import { amber } from '@mui/material/colors';

/*
Tools:
Color Tool: https://material.io/tools/color/
Color Hex: https://www.color-hex.com/color/f9eed9
*/

// default
// export const customMuiTheme = createMuiTheme();

// sexy redish color from https://www.bustle.com/articles/22110-color-science-reveals-which-shades-are-perceived-as-sexy-sad-calm-and-confident
// export const customMuiTheme = createMuiTheme({
//   typography: {
//     useNextVariants: true
//   },
//   palette: {
//     primary: {
//       // light: '#fcf8ef',
//       main: '#cd2144'
//       // dark: ''
//     },
//     secondary: {
//       main: '#C01823'
//     },
//     // play around with text color
//     text: {
//       secondary: amber[900]
//     }
//   }
// });

// pink color theme (glossier)
// export const customMuiTheme = createMuiTheme({
//   typography: {
//     useNextVariants: true
//   },
//   palette: {
//     primary: {
//       // shruti's color
//       main: '#e3687d',
//       // light: '#fcf8ef',
//       // main: '#f6e3e7',
//       dark: '#ecc5ce' // darker pink
//     },
//     secondary: {
//       main: '#e3f6f2',
//       dark: '#c5ece4'
//     },
//     // play around with text color
//     text: {
//       // secondary: amber[900]
//     }
//   }
// });
//
// Shared typography configuration
const sharedTypography = {
  useNextVariants: true,
  title: {
    fontSize: '24px',
    fontWeight: '400',
    letterSpacing: 'normal',
    lineHeight: '2rem'
  },
  title2: {
    fontSize: '20px',
    fontWeight: '500',
    letterSpacing: '0.15px',
    lineHeight: '2rem'
  },
  titleTab: {
    fontSize: '14px',
    fontWeight: '500',
    letterSpacing: '0.4px',
    lineHeight: '24.5px'
  },
  titleMobile: {
    fontSize: '20px',
    fontWeight: '400',
    letterSpacing: 'normal',
    lineHeight: '26.68px'
  }
};

// Light theme - pink skin colored theme (provacateur)
export const lightTheme = createTheme({
  typography: sharedTypography,
  palette: {
    mode: 'light',
    primary: {
      main: '#feede6',
      dark: '#fcccb8',
      superDark: '#f9976f'
    },
    secondary: {
      main: '#e6f7fe'
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.54)',
      meta: '#6b6b6b', // was #888888 (3.5:1, failed AA); #6b6b6b ~4.8:1 on white
      meta2: 'rgba(0, 0, 0, 0.54)',
      link: '#006cbd', // was #0079d3 (4.49:1, just under AA); #006cbd passes
      linkDark: '#336699'
    },
    background: {
      default: '#fafafa',
      paper: '#ffffff',
      tabs: '#feede6'
    }
  }
});

// Dark theme - clean, neutral cool-slate (no warm/red tint).
//
// IMPORTANT: in this app primary.main is used as a SURFACE color (header bars,
// banners, tab strips, contained CTA buttons - ~47 places) far more than as an
// accent, so in dark mode it must be a DARK neutral, not a bright color. The
// lighter accents that are used as TEXT (section titles, message meta) live in
// primary.dark / primary.superDark, which are a soft cool blue so they read on
// the dark surfaces. contrastText keeps button/banner text legible.
export const darkTheme = createTheme({
  typography: sharedTypography,
  palette: {
    mode: 'dark',
    primary: {
      light: '#3a414c',
      main: '#2e343d', // neutral slate - header/banner/button surfaces
      dark: '#9fb4d1', // soft cool blue - used as a TEXT accent on dark surfaces
      superDark: '#bcd2ec', // brighter cool blue - text accent (section titles)
      contrastText: '#f4f6f8'
    },
    secondary: {
      main: '#a5b4fc' // soft indigo accent
    },
    text: {
      primary: '#e8edf2', // clean light neutral
      secondary: 'rgba(232, 237, 242, 0.66)',
      meta: '#9aa4b2',
      meta2: 'rgba(232, 237, 242, 0.55)',
      link: '#8ab4f8', // accessible blue for links
      linkDark: '#aecbfa'
    },
    background: {
      default: '#0e1116', // cool neutral near-black
      paper: '#191d24', // neutral slate card surface
      tabs: '#272d36' // slightly lifted tab strips
    },
    divider: 'rgba(255, 255, 255, 0.10)',
    action: {
      hover: 'rgba(255, 255, 255, 0.06)',
      selected: 'rgba(138, 180, 248, 0.14)',
      active: '#8ab4f8'
    }
  }
});

// Default export for backward compatibility
export const customMuiTheme = lightTheme;

// yellow skin colored theme
// export const customMuiTheme = createMuiTheme({
//   palette: {
//     primary: {
//       // light: '#fcf8ef',
//       main: '#f9eed9',
//       // dark: '#f6e4c3'
//       dark: '#f2daad'
//       // dark: '#efd097'
//     },
//     secondary: {
//       main: '#C01823'
//     },
//     // play around with text color
//     text: {
//       secondary: amber[900]
//     }
//   }
// });

/*
primary colors: #f9eed9
secondary colors that compliment #f9eed9: #d9e4f9
that literary site uses #C01823
*/
